import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/art/productions")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t("Productions"),
  }),
})
